<template>
    <div>
        <loading-custom :loading="loading" />

        <div class="card mb-0">
            <div class="tw-grid md:tw-grid-cols-3 tw-gap-6">
                <!-- Background -->
                <div class="tw-col-span-1 tw-flex tw-justify-between">
                    <div class="md:px-4 py-4 sm:px-0">
                        <h3 class="tw-text-lg tw-font-medium tw-text-gray-900">
                            Background
                        </h3>
                        <p class="m-0 tw-text-sm tw-text-gray-600">
                            พื้นหลังเซลเพจ
                        </p>
                    </div>
                </div>
                <div class="tw-col-span-2 tw-flex">
                    <div class="md:px-4 py-4 sm:px-0 tw-w-full">
                        <div class="card border mb-0">
                            <div class="card-body">
                                <div class="tw-mb-2">
                                    <span class="tw-text-sm tw-font-bold tw-mb-2">สีพื้นหลัง</span>
                                    <div class="tw-flex tw-gap-2">
                                        <div v-for="(item, index) in colors" class="tw-flex tw-justify-center" :key="index"
                                            :class="`tw-w-8 tw-h-8 tw-cursor-pointer tw-border-2 
                                        tw-border-solid tw-rounded
                                        ${activeBgColor == item
                                                    ? 'tw-border-gray-500'
                                                    : 'tw-border-gray-100'
                                                }`
                                                " @click="activeBgColor = item" :style="`background:${item}`"><i
                                                class="fa fa-check tw-self-center"
                                                :class="index > 7 ? 'tw-text-white' : 'tw-text-black'"
                                                v-if="activeBgColor == item"></i></div>
                                    </div>
                                </div>
                                
                            </div>

                            <div class="card-footer">
                                <div class="col-lg-12 p-0">
                                    <div class="d-flex flex-row-reverse">
                                        <button type="button" class="btn btn-sm btn-success"
                                            @click="handleSubmit('background')">
                                            บันทึก
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Menu -->
                <div class="tw-col-span-1 tw-flex tw-justify-between">
                    <div class="md:px-4 py-4 sm:px-0">
                        <h3 class="tw-text-lg tw-font-medium tw-text-gray-900">
                            Menu
                        </h3>
                        <p class="m-0 tw-text-sm tw-text-gray-600">
                            แถบเมนูเซลเพจ
                        </p>
                    </div>
                </div>
                <div class="tw-col-span-2 tw-flex">
                    <div class="md:px-4 py-4 sm:px-0 tw-w-full">
                        <div class="card border mb-0">
                            <div class="card-body">
                                <div class="tw-mb-2">
                                    <span class="tw-text-sm tw-font-bold tw-mb-2">สีพื้นหลัง</span>
                                    <div class="tw-flex tw-gap-2">
                                        <div 
                                            v-for="(item, index) in colors" 
                                            class="tw-flex tw-justify-center" 
                                            :key="index"
                                            :class="`tw-w-8 tw-h-8 tw-cursor-pointer tw-border-2 
                                                tw-border-solid tw-rounded
                                                ${activeMenuColor == item
                                                            ? 'tw-border-gray-500'
                                                            : 'tw-border-gray-100'
                                                        }`" 
                                            @click="activeMenuColor = item" 
                                            :style="`background:${item}`"
                                        >
                                            <i class="fa fa-check tw-self-center"
                                                :class="index > 7 ? 'tw-text-white' : 'tw-text-black'"
                                                v-if="activeMenuColor == item">
                                            </i>
                                        </div>
                                    </div>
                                </div>
                                <div class="tw-mb-2">
                                    <span class="tw-text-sm tw-font-bold tw-mb-2">สีตัวอักษร</span>
                                    <div class="tw-flex tw-gap-2">
                                        <div 
                                            v-for="(item, index) in colors" 
                                            class="tw-flex tw-justify-center" 
                                            :key="index"
                                            :class="`tw-w-8 tw-h-8 tw-cursor-pointer tw-border-2 
                                                tw-border-solid tw-rounded
                                                ${activeMenuText == item
                                                            ? 'tw-border-gray-500'
                                                            : 'tw-border-gray-100'
                                                        }`
                                                " 
                                            @click="activeMenuText = item" 
                                            :style="`background:${item}`"
                                        >
                                            <i
                                                class="fa fa-check tw-self-center"
                                                :class="index > 7 ? 'tw-text-white' : 'tw-text-black'"
                                                v-if="activeMenuText == item">
                                            </i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card-footer">
                                <div class="col-lg-12 p-0">
                                    <div class="d-flex flex-row-reverse">
                                        <button type="button" class="btn btn-sm btn-success"
                                            @click="handleSubmit('menu')">
                                            บันทึก
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Button -->
                <div class="tw-col-span-1 tw-flex tw-justify-between">
                    <div class="md:px-4 py-4 sm:px-0">
                        <h3 class="tw-text-lg tw-font-medium tw-text-gray-900">
                            Button
                        </h3>
                        <p class="m-0 tw-text-sm tw-text-gray-600">
                            ปุ่มเซลเพจ
                        </p>
                    </div>
                </div>
                <div class="tw-col-span-2 tw-flex">
                    <div class="md:px-4 py-4 sm:px-0 tw-w-full">
                        <div class="card border mb-0">
                            <div class="card-body">
                                <div class="tw-mb-2">
                                    <span class="tw-text-sm tw-font-bold tw-mb-2">สีพื้นหลัง</span>
                                    <div class="tw-flex tw-gap-2">
                                        <div 
                                            v-for="(item, index) in colors" 
                                            class="tw-flex tw-justify-center" 
                                            :key="index"
                                            :class="`tw-w-8 tw-h-8 tw-cursor-pointer tw-border-2 
                                                tw-border-solid tw-rounded
                                                ${activeButtonColor == item
                                                            ? 'tw-border-gray-500'
                                                            : 'tw-border-gray-100'
                                                        }`
                                                "
                                             @click="activeButtonColor = item" 
                                             :style="`background:${item}`"
                                        >
                                            <i
                                                class="fa fa-check tw-self-center"
                                                :class="index > 7 ? 'tw-text-white' : 'tw-text-black'"
                                                v-if="activeButtonColor == item">
                                            </i>
                                        </div>
                                    </div>
                                </div>
                                <div class="tw-mb-2">
                                    <span class="tw-text-sm tw-font-bold tw-mb-2">สีตัวอักษร</span>
                                    <div class="tw-flex tw-gap-2">
                                        <div v-for="(item, index) in colors" class="tw-flex tw-justify-center" :key="index"
                                            :class="`tw-w-8 tw-h-8 tw-cursor-pointer tw-border-2 
                                        tw-border-solid tw-rounded
                                        ${activeButtonText == item
                                                    ? 'tw-border-gray-500'
                                                    : 'tw-border-gray-100'
                                                }`
                                                " @click="activeButtonText = item" :style="`background:${item}`"><i
                                                class="fa fa-check tw-self-center"
                                                :class="index > 7 ? 'tw-text-white' : 'tw-text-black'"
                                                v-if="activeButtonText == item"></i></div>
                                    </div>
                                </div>
                            </div>

                            <div class="card-footer">
                                <div class="col-lg-12 p-0">
                                    <div class="d-flex flex-row-reverse">
                                        <button type="button" class="btn btn-sm btn-success"
                                            @click="handleSubmit('button')">
                                            บันทึก
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["shop", "salePage"],
    data() {
        return {
            loading: false,
            colors: [
                "#ffffff",
                "#00CED1",
                "#20B2AA",
                "#fdd836",
                "#FFD700",
                "#FFA07A",
                "#FF6347",
                "#FF4500",
                "#DC143C",
                "#9932CC",
                "#28a745",
                "#FF1493",
                "#8B4513",
                "#000000"
            ],
            activeBgColor: "",

            activeMenuColor: "",
            activeMenuText: "",

            activeButtonColor: "",
            activeButtonText: "",
        };
    },
    mounted() {
        this.getDefaultColor();
    },
    methods: {
        getDefaultColor() {
            this.loading = true;
            axios
                .get(
                    `/backend/s/${this.shop}/salepages/${this.salePage.id}/background`
                )
                .then(res => {
                    this.loading = false;
                    this.activeBgColor = res.data.data.background_color;
                    this.activeMenuColor = res.data.data.menu_color;
                    this.activeButtonColor = res.data.data.button_color;

                    this.activeMenuText = res.data.data.menu_text;
                    this.activeButtonText = res.data.data.button_text;
                    
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        handleSubmit(section) {
            let form = null;

            if (section == "background") {
                if (!!this.activeBgColor) {
                    this.loading = true;
                    form = {
                        background: this.activeBgColor,
                    };
                }
            } else if (section == "menu") {
                if (!!this.activeMenuColor && !!this.activeMenuText) {
                    this.loading = true;
                    form = {
                        menu_color: this.activeMenuColor,
                        menu_text: this.activeMenuText
                    };
                }
            } else if (section == "button") {
                if (!!this.activeButtonColor && !!this.activeButtonText) {
                    this.loading = true;
                    form = {
                        button_color: this.activeButtonColor,
                        button_text: this.activeButtonText
                    };
                }
            }
            
            if (!!form) {
                axios
                    .post(
                        `/backend/s/${this.shop}/salepages/${this.salePage.id}/background`,
                        form
                    )
                    .then(res => {
                        this.loading = false;
                        this.messageAlert(
                            "success",
                            "บันทึกสำเร็จ",
                            `ระบบบันทึกสี${section == "background" ? "พื้นหลัง" : section == "menu" ? "เมนู" : "ปุ่ม"}เซลเพจเสร็จสิ้น`
                        );
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            }
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        }
    }
};
</script>

<style>
.center {
    position: relative;
    top: 50%;
    left: 50%;
}
</style>
